// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"IOI4Uwqj"};